'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$RestrictedDomainName$$anon$149(outer) {
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
}
export { $c_Lpresto_types$RestrictedDomainName$$anon$149 as $c_Lpresto_types$RestrictedDomainName$$anon$149 };
$p = $c_Lpresto_types$RestrictedDomainName$$anon$149.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$RestrictedDomainName$$anon$149;
/** @constructor */
function $h_Lpresto_types$RestrictedDomainName$$anon$149() {
}
export { $h_Lpresto_types$RestrictedDomainName$$anon$149 as $h_Lpresto_types$RestrictedDomainName$$anon$149 };
$h_Lpresto_types$RestrictedDomainName$$anon$149.prototype = $p;
$p.cD = (function(x, y) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_s_math_Ordering__lteq__O__O__Z(this, x, y);
});
$p.cA = (function(x, y) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_s_math_Ordering__gteq__O__O__Z(this, x, y);
});
$p.cs = (function(x, y) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_s_math_Ordering__lt__O__O__Z(this, x, y);
});
$p.ct = (function(x, y) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_s_math_Ordering__max__O__O__O(this, x, y);
});
$p.cK = (function(x, y) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_s_math_Ordering__min__O__O__O(this, x, y);
});
$p.cB = (function(other) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_s_math_Ordering__isReverseOf__s_math_Ordering__Z(this, other);
});
$p.b4 = (function(x, y) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_T__compareTo__T__I(x, y);
});
var $d_Lpresto_types$RestrictedDomainName$$anon$149 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$RestrictedDomainName$$anon$149, "presto.types$RestrictedDomainName$$anon$149", ({
  a18: 1,
  O: 1,
  a: 1,
  Q: 1,
  U: 1,
  W: 1
}));
export { $d_Lpresto_types$RestrictedDomainName$$anon$149 as $d_Lpresto_types$RestrictedDomainName$$anon$149 };
//# sourceMappingURL=presto.types$-Restricted-Domain-Name$$anon$149.js.map
